import { connect } from "react-redux";
import React, { useEffect, useState,Fragment,useRef } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import * as logger from '../../../../logger';
import {
    DialogTitle,
    Paper,
    Grid,
    Button,
    ExpansionPanelDetails,
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    InputAdornment,
    Card,
    CardContent,
    Typography,
} from '@material-ui/core';
import { TripBookCss as useStyles } from '../VehicleCss';
import { TRIP_FILTER_STATUS_MAPPING } from '../../../../store/constants';
import RightSideBar from '../../../components/RightSideBar/RightSideBar';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { singleTruck, fetchTripBook,fetchTripBookV2,fetchTripBookV3, PandL, Expenses } from '../../../../store/actions/vehicleActionCreator';
import { getAllPnlMonths } from '../../../../store/actions/homeActionCreator';
import { getTripDetailsV3,getJourneyDetails } from '../../../../store/actions/tripActionCreator';
import { titleVehicleNumber, numberFormat, getDateInStringDocumentDDMMMYYYY, numberFormatComma, getDateFilterValueForMonthlyBalance, getTripDateFilterValues } from '../../../../utils/utils';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import DateFilter from '../../../components/FilterComponent/DateFilter';
import AddEditTripSideBar from '../../../components/Trip/AddEditTripSideBar';
import TripCompleteActionDialog from '../../../components/Trip/TripCompleteActionDialog';
import ReportsDialog from '../../../components/ReportsDialog/ReportsDialog';
import CustomDateFilterDialog from '../../../components/FilterComponent/CustomDateFilter';
import { trackDwebEvent } from "../../../analytics";
import { Waypoint } from "react-waypoint";
import { debounce } from 'lodash';
import { defaultPageNo,defaultPageSize } from "../../../../paginationVariables";
import moment from 'moment';
const scrollToRef = (ref) => window.scrollTo(0, 0)
const TripBook = ({ open, onClose, dispatchGetPandL, dispatchTripDetailsAction, dispatchGetTripExpenses, dispatchGetSingleTruck, dispatchGetTripBook, dispatchGetPnlMonths, vehicle }) => {

    let submit, formValues;

    const [onOpen, setOnOpen] = useState(null);
    const [tripBookDetails, setTripBookDetails] = useState({});
    // const [startDateRange, setStartDateRange] = useState({});
    const [changeDataFlag, setChangeDataFlag] = useState(false);
    const [addTripSideBarOpen, setAddTripSideBarOpen] = useState(false);
    const [completeTripOpen, setCompleteTripOpen] = useState(false);
    const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
    const [dateFilterValue, setDateFilterValue] = useState("ALL_MONTHS");
    const [customFilter, setCustomFilter] = useState(false);
    const [customFilterValue, setCustomFilterValue] = useState({});
    const [currentPageNo,setCurrentPageNo]  = useState(defaultPageNo);
    const [currentPageSize,setCurrentPageSize]  = useState(defaultPageSize);
    const [filteredPNL,setFilteredPNL]  = useState(defaultPageSize);

    const classes = useStyles();

    const myRef = useRef(null)
    const executeScroll = () => {
        let el = document.getElementById('trip-book-single-vehicle');
        el.scrollTop = 0;
    }

    const vehicleNumberTypes = {
        vehicleNumberPrefix: vehicle && vehicle.truckBooks && vehicle.truckBooks.vehicleNumberPrefix ? vehicle.truckBooks.vehicleNumberPrefix : "",
        vehicleNumberSuffix: vehicle && vehicle.truckBooks && vehicle.truckBooks.vehicleNumberSuffix ? vehicle.truckBooks.vehicleNumberSuffix : ""
    }

    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    let location = useLocation();
    let history = useHistory();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let vehicleId = path && path[path.length - 1] ? path[path.length - 1] : "";
    let singleTruckData = vehicle.singleTruck;

    var date = new Date();
    let monthName = date.getMonth();
    let year = date.getFullYear();
    var monthDate = monthNames[monthName] + " " + year;

    useEffect(() => {

        if (tripBookDetails && tripBookDetails.vehicleNumber) {
            trackDwebEvent("Dweb SVP Trip Book", {
                vehicle_id: tripBookDetails && tripBookDetails.vehicleId ? tripBookDetails.vehicleId : "",
                vehicle_number: tripBookDetails && tripBookDetails.vehicleNumber ? tripBookDetails.vehicleNumber : "",
                trip_revenue: tripBookDetails && tripBookDetails.totalRevenue ? tripBookDetails.totalRevenue : "",
                trip_expenses: tripBookDetails && tripBookDetails.tripExpense ? tripBookDetails.tripExpense : "",
                trip_profit: tripBookDetails && tripBookDetails.tripMargin ? tripBookDetails.tripMargin : ""
            });
        }

    }, [tripBookDetails]);
    const getDateRangeValue = ()=>{
        var dateFilterValueUtil = getTripDateFilterValues();
        var startDateRange = dateFilterValueUtil[dateFilterValue].startDateRange;
        let date = `${moment(startDateRange["startTimeEpoch"]*1000).format('YYYY-MM-DD')},${moment(startDateRange["endTimeEpoch"]*1000).format('YYYY-MM-DD')}`;
        if (customFilterValue && customFilterValue.startTimeEpoch) {
          date = `${moment(customFilterValue["startTimeEpoch"]*1000).format('YYYY-MM-DD')},${moment(customFilterValue["endTimeEpoch"]*1000).format('YYYY-MM-DD')}`;
        }
        return [date]
    }
    const getPaginatedData =()=>{
        var dateFilterValueUtil = getTripDateFilterValues();
        var startDateRange = dateFilterValueUtil[dateFilterValue].startDateRange;

        var tripBookdata = {
            vehicleId: Number(vehicleId),
            status: TRIP_FILTER_STATUS_MAPPING["ALL"],
            pageNo: currentPageNo+1,
            pageSize: currentPageSize,
            merge:true,
            filters: [
                {
                    "filterKey": "vehicleId",
                    "values": [vehicleId]
                },
                {
                    "filterKey": "tripStatus",
                    "values": TRIP_FILTER_STATUS_MAPPING["ALL"]
                },
                {
                    "filterKey": "startDate",
                    "values": getDateRangeValue()
                }
            ],
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            }
        }

        if (customFilterValue && customFilterValue.startTimeEpoch) {
            tripBookdata.startDateRange.startTimeEpoch = customFilterValue.startTimeEpoch;
            tripBookdata.startDateRange.endTimeEpoch = customFilterValue.endTimeEpoch;
        }

        dispatchGetTripBook(tripBookdata,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Trip Book", "Get trip book successfull");
                    setTripBookDetails({
                        ...data.response,
                        journeys:[
                            ...tripBookDetails.journeys,
                            ...data.response.journeys
                        ]
                    })
                    setOnOpen(open);
                }
            },
            () => {
                logger.log("Trip Book", "Get trip book failed");
            }
        );
    }
    useEffect(() => {

        // let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        // let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        // let firstDayValue = (firstDay.setHours(0, 0, 0, 0)) / 1000;
        // let lastDayValue = (lastDay.setHours(23, 59, 59)) / 1000;
        var dateFilterValueUtil = getTripDateFilterValues();
        var startDateRange = dateFilterValueUtil[dateFilterValue].startDateRange;


        var tripBookdata = {
            vehicleId: Number(vehicleId),
            status: TRIP_FILTER_STATUS_MAPPING["ALL"],
            pageNo: defaultPageNo,
            pageSize: defaultPageSize,
            filters: [
                {
                    "filterKey": "vehicleId",
                    "values": [vehicleId]
                },
                {
                    "filterKey": "tripStatus",
                    "values": TRIP_FILTER_STATUS_MAPPING["ALL"]
                },
                {
                  "filterKey": "startDate",
                  "values": getDateRangeValue()
                }
            ],
            tripStatus:TRIP_FILTER_STATUS_MAPPING["ALL"],
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            }
        }

        dispatchGetSingleTruck(Number(vehicleId),
            () => {
                logger.log("Trip Book Dweb", 'Get single truck successfull')
                dispatchGetPnlMonths({},
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log("Trip Book", "Get PNL months successfull");
                            dispatchGetTripBook(tripBookdata,
                                (data) => {
                                    if (data && data.status && data.status.code == 200) {
                                        logger.log("Trip Book", "Get trip book successfull");
                                        setTripBookDetails(data.response)
                                        dispatchGetPandL(tripBookdata, null,
                                            (data) => {
                                                if (data && data.status && data.status.code == 200) {
                                                    setFilteredPNL(data.response)
                                                    setOnOpen(open);
                                                }
                                            },
                                            () => {
                                            },
                                            true,
                                        )
                                    }
                                },
                                () => {
                                    logger.log("Trip Book", "Get trip book failed")
                                }
                            );
                        }
                    },
                    () => {
                        logger.log("Trip Book", "Get PNL months failed");
                    }
                );
            },
            () => {
                logger.log("Trip Book Dweb", 'Get single truck failed')
            }
        );


    }, [open]);

    useEffect(() => {
        if (changeDataFlag) {
            setCurrentPageNo(defaultPageNo);
            executeScroll()
            var dateFilterValueUtil = getTripDateFilterValues();
            var startDateRange = dateFilterValueUtil[dateFilterValue].startDateRange;

            var tripBookdata = {
                vehicleId: Number(vehicleId),
                status: TRIP_FILTER_STATUS_MAPPING["ALL"],
                pageNo: defaultPageNo,
                pageSize: defaultPageSize,
                filters: [
                    {
                        "filterKey": "vehicleId",
                        "values": [vehicleId]
                    },
                    {
                        "filterKey": "tripStatus",
                        "values": TRIP_FILTER_STATUS_MAPPING["ALL"]
                    },
                    {
                      "filterKey": "startDate",
                      "values": getDateRangeValue()
                    }
                ],
                startDateRange: {
                    startTimeEpoch: startDateRange.startTimeEpoch,
                    endTimeEpoch: startDateRange.endTimeEpoch
                }
            }

            if (customFilterValue && customFilterValue.startTimeEpoch) {
                tripBookdata.startDateRange.startTimeEpoch = customFilterValue.startTimeEpoch;
                tripBookdata.startDateRange.endTimeEpoch = customFilterValue.endTimeEpoch;
            }

            dispatchGetTripBook(tripBookdata,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Trip Book", "Get trip book successfull");
                        setTripBookDetails(data.response)
                        dispatchGetPandL(tripBookdata, null,
                            (data) => {
                                if (data && data.status && data.status.code == 200) {
                                    setFilteredPNL(data.response)
                                    setOnOpen(open);
                                }
                            },
                            () => {
                            },
                            true
                        )
                    }
                },
                () => {
                    logger.log("Trip Book", "Get trip book failed");
                }
            );
        }
    }, [dateFilterValue, customFilterValue]);

    const handleTripView = (tripId) => {
        dispatchTripDetailsAction(tripId,
            (data) => {
                if (data && data.status && data.status.code) {
                    logger.log("Trip Book Dweb", "Fetch Trip Successfull");
                    history.push({
                        pathname: `/trips/view/${tripId}`,
                        state: {
                            id: 7,
                            tripData: data,
                            tripView: true,
                            pageTitle: 'Trip Details',
                            pageSubTitle: data && data.vehicleNumber ? data.vehicleNumber : ''
                        }
                    });
                }
            },
            () => {
                logger.log("Trip Book Dweb", "Fetch Trip Failed");
            }
        );
    }

    const onConfirm = () => {
        setOnOpen(false);
        onClose();
    }

    // const handleMonthlyBalanceDate = (value) => {
    //     let dateValue = getDateFilterValueForMonthlyBalance(value);
    //     setStartDateRange(dateValue.startDateRange);
    //     setChangeDataFlag(true);
    // }


    const handleDateValue = (value) => {
        // setDateFilterValue(value);
        if (value == "CUSTOM") {
            setCustomFilter(true);
        }
        else {
            // var dateFilterValueUtil = getTripDateFilterValues();
            // setStartDateRange(dateFilterValueUtil[value].startDateRange);
            setDateFilterValue(value);
            setCustomFilter(false);
            setCustomFilterValue({});
        }
        setChangeDataFlag(true);
    }

    const handleAddTrip = () => {

        if (singleTruckData.status == "ONTRIP") {
            setCompleteTripOpen(true);
        } else {
            setAddTripSideBarOpen(true);
        }

    }

    const handleAddTripSideBarClose = () => {
        setAddTripSideBarOpen(false);
    };

    const handleTripCompleteActionClose = () => {
        setCompleteTripOpen(false);
    }

    const handleTripCompleteActionConfirm = () => {
        let id = singleTruckData && singleTruckData.id ? singleTruckData.id : ""
        let prefix = singleTruckData && singleTruckData.vehicleNumberPrefix ? singleTruckData.vehicleNumberPrefix : "";
        let suffix = singleTruckData && singleTruckData.vehicleNumberSuffix ? singleTruckData.vehicleNumberSuffix : "";
        let ownershipTypeValue = singleTruckData && singleTruckData.ownershipType ? singleTruckData.ownershipType : "";
        let bodyTypeValue = singleTruckData && singleTruckData.vehicleBodyType ? singleTruckData.vehicleBodyType : "";

        setCompleteTripOpen(false);
        singleTruckRecall(id, prefix, suffix, ownershipTypeValue, bodyTypeValue);
    }

    const singleTruckRecall = (id, prefix, suffix, ownershipTypeValue, bodyTypeValue) => {

        var dateFilterValueUtil = getTripDateFilterValues();

        var startDateRange = dateFilterValueUtil["ALL_MONTHS"].startDateRange;

        var PandLdata = {
            vehicleId: id,
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            }
        };

        var expenseData = {
            vehicleId: id,
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            },
            expenseParentType: []
        };

        let defaultDateFilterValue = "ALL_MONTHS";
        let defaultTripBookFilterValue = "All Trips & Expenses";

        dispatchGetSingleTruck(id,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Successfull ");
                    dispatchGetPandL(PandLdata, defaultDateFilterValue,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Single Vehicle Component Dweb", "Get P and L report Successfull");
                                dispatchGetTripExpenses(expenseData, defaultTripBookFilterValue,
                                    (data) => {
                                        if (data && data.status && data.status.code == 200) {
                                            logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Successfull");
                                            setAddTripSideBarOpen(true);
                                            history.push({
                                                pathname: `/trucks/single-truck/${id}`,
                                                state: {
                                                    id: 8,
                                                    vehicleStatus: "Available",
                                                    pageTitle: (prefix && suffix) ? [prefix, suffix] : null,
                                                    vehicleId: id,
                                                    ownershipType: ownershipTypeValue,
                                                    bodyType: bodyTypeValue
                                                }
                                            });
                                        }
                                    },
                                    () => {
                                        logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Failed");
                                    },
                                )
                            }
                        },
                        () => {
                            logger.log("Single Vehicle Component Dweb", "Get P and L report Failed");
                        },
                    )
                }
            },
            () => {
                logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Failed");
            }
        );
    }

    const handleViewPdf = () => {
        trackDwebEvent("Dweb SVP Trip Book PDF Initiated", {
            vehicle_id: tripBookDetails && tripBookDetails.vehicleId ? tripBookDetails.vehicleId : "",
            vehicle_number: tripBookDetails && tripBookDetails.vehicleNumber ? tripBookDetails.vehicleNumber : "",
        })
        setReportsDialogOpen(true);
    }

    const handleReportsDialogClose = () => {
        setReportsDialogOpen(false);
    }

    const handleCustomFilterClose = () => {
        setCustomFilter(false);
    }

    const handleCustomFilterConfirm = (value) => {
        setDateFilterValue("CUSTOM");
        setCustomFilter(false);
        setCustomFilterValue(value);
    }
    const getTripCard = (item,journeyId)=>{
        return (<>
            <Typography variant="subtitle2" className={classes.tripLogCustomer}>
                {item && item.customer && item.customer.customerName ? item.customer.customerName : ''}
                <div className={classes.divProfitHeader}>
                    <>
                        {item.profit > 0 &&
                            <>
                                <div className={classes.profitHeader}>Profit</div>
                                <div className={classes.profitAmount}>{numberFormat(item.profit)}</div>
                            </>
                        }
                        {item.profit < 0 &&
                            <>
                                <div className={classes.profitHeader}>Loss</div>
                                <div className={classes.profitAmountLoss}><span className={classes.mrV1}>-</span>{numberFormat(item.profit * -1)}</div>
                            </>
                        }
                        {item.profit == 0 &&
                            <>
                                <div className={classes.profitHeader}>Profit</div>
                                <div className={classes.fsV2}>{numberFormat(item.profit)}</div>
                            </>
                        }
                    </>
                </div>
            </Typography>
        <div style={{ display: 'flex', justifyContent: 'space-between', height: '4.265em' }}>
        <div>
            <Timeline classes={{ root: classes.timeLineRoot }}>
                <TimelineItem classes={{ missingOppositeContent: classes.timelineItem, root: classes.timeLineItemRoot1 }}>
                    <TimelineSeparator>
                        <TimelineDot variant="outlined" classes={{ defaultGrey: classes.timeLineDot, root: classes.timeLineDotRoot }} />
                        <TimelineConnector classes={{ root: classes.timeLineConnector }} />
                    </TimelineSeparator>
                    <TimelineContent classes={{ root: classes.timeLineContent1 }}>{item.startLocation}
                        {/* {expenseDetails.tripInfo.startDate && */}
                        <span className={classes.bullet}>•</span>

                        <span>{getDateInStringDocumentDDMMMYYYY(item.startDate)}</span>
                        {item.startOdometerReading && item.startOdometerReading != 0 &&
                            <>
                                <span className={classes.bullet}>•</span>
                                <span>{numberFormatComma(item.startOdometerReading)} KMs</span>
                            </>
                        }
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem classes={{ missingOppositeContent: classes.timelineItem, root: classes.timeLineItemRoot1 }}>
                    <TimelineSeparator>
                        <TimelineDot variant="outlined" classes={{ defaultGrey: classes.timeLineDot, root: classes.timeLineDotRoot }} />
                    </TimelineSeparator>
                    <TimelineContent classes={{ root: classes.timeLineContent1 }}>{item.destinationLocation}
                        {/* {expenseDetails.tripInfo.completedDate && */}
                        {item.completedDate &&
                            <>
                                <span className={classes.bullet}>•</span>
                                {/* } */}
                                <span style={{ fontWeight: 'lighter' }}>{getDateInStringDocumentDDMMMYYYY(item.completedDate)}</span>
                            </>
                        }
                        {item.endOdometerReading &&
                            <>
                                <span className={classes.bullet}>•</span>
                                <span>{numberFormatComma(item.endOdometerReading)} KMs</span>
                            </>

                        }
                    </TimelineContent>
                </TimelineItem>
            </Timeline>
        </div>
        <div className={classes.divView} onClick={() => handleTripView(journeyId)}>
            <div>View  <ArrowForwardIosIcon className={classes.divArrow} /></div>
        </div>
    </div>
        </>)
    }
    const getCard = (item)=>{
        return (<div>
            <Card className={classes.svLogCard1}>
                <CardContent className={classes.tripBookCardContent}>
                    {item && item.trips.map((trip,index) => {
                                if (index ===  item.trips.length-1) {
                                    return getTripCard(trip,item.id);
                                } else {
                                    return <>
                                        {getTripCard(trip,item.id)}
                                        <div className={classes.seperator}></div>
                                    </>
                                }
                            })
                    } 
                </CardContent>
            </Card>
        </div>)
    }

    tripBookDetails.id = vehicle.truckBooks && vehicle.truckBooks.vehicleId ? vehicle.truckBooks.vehicleId : ""

    return (
        <>
            {onOpen && <RightSideBar
                sideBarName="trip-book"
                rightSideBarOpen={onOpen}
                sideBarTitle={'Trip Book'}
                sideBarType="truckBook"
                addTripClicked={handleAddTrip}
                vehicleNumberValue={vehicleNumberTypes}
                truckType={tripBookDetails && tripBookDetails.vehicleBodyType ? tripBookDetails.vehicleBodyType : ""}
                handleSubmit={event => submit(event)}
                toggleRightSideBar={onConfirm} >
                <div className={classes.divV1}>
                    <>
                        {vehicle && vehicle.pandl && vehicle.pandl.totalTrips <= 0 &&
                            <div className={classes.divEmpty}>
                                <img src={tripBookDetails.icon} width='155px' ></img>
                                <div className={classes.emptyState}>Add your Trips to get monthly Truck revenue</div>
                            </div>
                        }
                        {vehicle && vehicle.pandl && vehicle.pandl.totalTrips > 0 &&
                            <>
                                <div className={classes.divV2}>
                                    <div>
                                        <div className={classes.dateRange}>Date Range</div>
                                        {/* <FilterComponent reportType={"Trip Book"} monthlyDate={handleMonthlyBalanceDate} fromMonthlyBalance={true} monthlyDateValue={monthDate} /> */}
                                        <DateFilter dateValue={handleDateValue} fromSingleVehicle={true} defaultValue={dateFilterValue} />
                                    </div>
                                    <div>
                                        <Button variant="contained" classes={{ root: classes.viewPDFCta }} color="primary" onClick={() => handleViewPdf()}>
                                            <PictureAsPdfIcon />&nbsp;View PDF
                                        </Button>
                                    </div>
                                </div>

                                <div className={classes.marginV1}>
                                    <Card style={{ borderRadius: 8 }}>
                                        <CardContent className={classes.cardContentV1}>
                                            <div>
                                                <div className={classes.titleV1}>Total Revenue</div>
                                                <div className={classes.totalRevenue}>{filteredPNL.totalRevenue ? numberFormat(filteredPNL.totalRevenue) : "---"}</div>
                                            </div>
                                            <div>
                                                <div className={classes.titleV1}>Trip Expenses</div>
                                                <div className={classes.totalRevenue}>{filteredPNL.tripExpenses? numberFormat(filteredPNL.tripExpenses) : "---"}</div>
                                            </div>
                                            {filteredPNL.tripProfit > 0 &&
                                                <div className={classes.divTripProfit}>
                                                    <div className={classes.titleV1}>Trip Profit</div>
                                                    <div className={classes.totalRevenue}><span className={classes.profit}>{filteredPNL.tripProfit? numberFormat(filteredPNL.tripProfit) : ""}</span></div>
                                                </div>
                                            }
                                            {filteredPNL.tripProfit == 0 &&
                                                <div className={classes.divTripProfit}>
                                                    <div className={classes.titleV1}>Trip Profit</div>
                                                    <div className={classes.totalRevenue}><span>{filteredPNL.tripProfit ? numberFormat(filteredPNL.tripProfit) : "---"}</span></div>
                                                </div>
                                            }
                                            {filteredPNL.tripProfit < 0 &&
                                                <div className={classes.divTripProfit}>
                                                    <div className={classes.titleV1}>Trip Profit</div>
                                                    <div className={classes.totalRevenue}><span className={classes.loss}><span className={classes.mrV1}>-</span>{filteredPNL.tripProfit ? numberFormat(filteredPNL.tripProfit * -1) : ""}</span></div>
                                                </div>
                                            }
                                        </CardContent>
                                    </Card>
                                </div>

                                <div id="trip-book-single-vehicle" className={classes.tripCardsLists} ref={myRef}>
                                        <>
                                            {/* <div className={classes.tripMonth}>{tripLog.month}</div> */}
                                            {tripBookDetails && tripBookDetails.journeys.map((item,index) => {
                                                   if (index ===  tripBookDetails.journeys.length-1) {
                                                     return (
                                                       <Fragment>
                                                         <Waypoint
                                                           onEnter={() => {
                                                             if(tripBookDetails && tripBookDetails.maxPage && tripBookDetails.maxPage != currentPageNo){
                                                               getPaginatedData()
                                                               setCurrentPageNo(currentPageNo+1)
                                                             }
                                                           }}
                                                         />
                                                         {getCard(item)}
                                                       </Fragment>
                                                     );
                                                   } else {
                                                       return getCard(item);
                                                   }
                                                })
                                            }
                                        </>
                                </div>
                            </>
                        }
                    </>
                </div>
            </RightSideBar>
            }
            {addTripSideBarOpen && <AddEditTripSideBar sideBarTitle="Add Trip" sideBarOpen={addTripSideBarOpen} sideBarClose={handleAddTripSideBarClose} tripId={null} vehicleDataFromSingleTruck={tripBookDetails ? tripBookDetails : ""} driverDataFromTruckBook={vehicle && vehicle.singleTruck && vehicle.singleTruck.driver ? vehicle.singleTruck.driver : ""} supplierDataFromTruckBook={vehicle && vehicle.singleTruck && vehicle.singleTruck.vendor ? vehicle.singleTruck.vendor : ""} />}
            {completeTripOpen && <TripCompleteActionDialog tripId={singleTruckData && singleTruckData.tripId ? singleTruckData.tripId : ""} open={completeTripOpen} onClose={handleTripCompleteActionClose} onSave={handleTripCompleteActionConfirm} />}
            {reportsDialogOpen && <ReportsDialog open={reportsDialogOpen} onClose={handleReportsDialogClose} name={"Trip Profit & Loss Report"} vehicleIdValue={vehicleId ? vehicleId : null} />}
            {customFilter && <CustomDateFilterDialog open={customFilter} onClose={handleCustomFilterClose} onConfirm={handleCustomFilterConfirm} />}

        </>
    );

}


const mapStateToProps = (state) => ({ vehicle: state.vehicle })
const mapDispatchToProps = (dispatch) => ({
    dispatchGetSingleTruck: (truckId, onSuccess, onFailure) => dispatch(singleTruck(truckId, onSuccess, onFailure)),
    dispatchGetTripBook: (data, onSuccess, onFailure) => { dispatch(fetchTripBookV3(data, onSuccess, onFailure)) },
    dispatchGetPnlMonths: (requestData, onSuccess, onFailure) => {
        dispatch(getAllPnlMonths(requestData, onSuccess, onFailure))
    },
    dispatchTripDetailsAction: (tripId, onSuccess, onError) => {
        dispatch(getJourneyDetails(tripId, onSuccess, onError))
    },
    dispatchGetPandL: (data, defaultDateFilterValue, onSuccess, onFailure,empty) => dispatch(PandL(data, defaultDateFilterValue, onSuccess, onFailure,empty)),
    dispatchGetTripExpenses: (data, defaultTripBookFilterValue, onSuccess, onFailure) => dispatch(Expenses(data, defaultTripBookFilterValue, onSuccess, onFailure)),
});
export default connect(mapStateToProps, mapDispatchToProps)(TripBook);
